import useCustomer from './useCustomer';


function useCustomerInterest() {

    const {interest} = useCustomer();

    return interest;
}


export default useCustomerInterest;
